import { useState } from 'react'

const COPIED_TIMEOUT = 1000

const useCopy = (text: string) => {
  const [copied, setCopied] = useState(false)

  const copy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, COPIED_TIMEOUT)
  }

  const result = { copied, copy }

  return result
}

export default useCopy
